import React from 'react';
import { Field } from 'redux-form'

class SRACheckboxField extends React.Component {

    render () {
        return (
            <div>
                <Field
                    name={this.props.value}
                    component='input'
                    type='checkbox'
                    id={`question${this.props.questionID}${this.props._key}`}
                    checked={this.props.checked}
                    onClick={(e) => {
                        this.props.selectAnswer(
                            this.props.questionID,
                            e.target,
                            this.props.nextQuestion)
                    }}
                />
                <span>{this.props.value}</span>
                <span className="checkmark">
                </span>

            </div>
        )
    }

}

export default SRACheckboxField


// WEBPACK FOOTER //
// ./src/components/sra/components/SRACheckboxField.js